import axios from 'axios';

const state = {
  errorBit: false,
  errorInfo: "",
};

const mutations = {
  SET_ERROR_BIT: (state, errorBit) => {
    state.errorBit = errorBit;
  },
  SET_ERROR_INFO: (state, errorInfo) => {
    state.errorInfo = errorInfo;
  },
};

const getters = {
  errorBit: (state) => state.errorBit,
  errorInfo: (state) => state.errorInfo,
};

const errorHandler = {
  state,
  getters,
  mutations,

  // Log error details with stack trace and performance stats
  logError(type, error) {
    let performance = window.performance;

    /*console.log(`Error Type: ${type}`);
    console.log('Error:', error);
    console.log('Stack Trace:', error.stack);
    console.log('Error payload:', error.requestPayload);
    //console.log('Memory Usage:', `${(performance.memory.usedJSHeapSize / 1048576).toFixed(2)} MB / ${(performance.memory.jsHeapSizeLimit / 1048576).toFixed(2)} MB`);
    console.log('Client Info:', {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      language: navigator.language
    });*/

    //state.errorBit = true;
    //state.errorInfo = "Error details...";

    /*throw new Error(
        "<br>" +
        "Server responded with error = True <br> errorCode: "
    );*/
  },

  install(Vue) {
    // Add axios to Vue prototype
    //console.log("Installing custom error logger...");
    // Add axios request interceptor
    axios.interceptors.request.use((config) => {
      // Attach request payload to the config
      config.metadata = { startTime: new Date(), payload: config.data }; // Logging start time, and the initial request data.
      return config;
    });

    // Add axios response interceptor
    axios.interceptors.response.use((response) => {
      // Check for "error" flag in the response data

      const endTime = new Date();
      const duration = endTime - response.config.metadata.startTime;
      // Attach request payload to the response
      //response.requestPayload = response.config.metadata.payload;

      if (response.data && response.data.error) {
        const error = new Error(response.data.errorCode || 'An error occurred');
        //error.requestPayload = response.requestPayload;
        error.duration = duration;

        this.logError('HTTP Error', error);
        return Promise.reject(error);
      }

      return response;
    }, (error) => {
      if (error.config) {
        error.requestPayload = error.config;
      }
      this.logError('HTTP Error', error);
      return Promise.reject(error);
    });

    // Add Vue error handler
    Vue.config.errorHandler = (error, vm, info) => {
      //this.logError('Vue Error', error);
      //console.log('Vue error info:', info);
    };

    // Add window error listener
    window.addEventListener('error', (event) => {
      //this.logError('Global Error', event.error);
    });
  }
};

export default errorHandler;
